import { graphql } from '@/generated/gql';

export const BASE_SUPPLIER_LIST_QUERY = graphql(/* GraphQL */ `
  query BaseSupplierList(
    $offset: Int
    $limit: Int
    $filter: JSON
    $order: [SupplierSortOrder!]
    $skipExport: Boolean = false
  ) {
    suppliers(offset: $offset, limit: $limit, filter: $filter, order: $order) {
      nodes {
        id
        name
        externalId
        orderCount
        orderCountYear
        orderVolume
        orderVolumeYear
        revenue
        ebit
        peRatio
        employeeCount
        quotationSuccessRate
        orderLastDate
        prequalificationLevel
        prequalificationTrades {
          name
          status
        }
        locationGroupList {
          id
          name
        }
        relationship
        contact {
          fax
          phone
          email
          website
        }
        industry {
          id
          name
        }
        legalType {
          id
          name
        }
        address {
          city
          street
          postalCode
          countryCode
        }
        location {
          lat
          lng
        }
        activeContractCount
        activeContractList @skip(if: $skipExport) {
          id
          name
        }
        representativeCount
        representativeList @skip(if: $skipExport) {
          id
          name
        }
        orderedProductCount
        orderedProductList @skip(if: $skipExport) {
          id
          name
        }
        orderedServiceCount
        orderedServiceList @skip(if: $skipExport) {
          id
          name
        }
        orderedProductInCategoryCount
        orderedProductInCategoryList @skip(if: $skipExport) {
          id
          name
        }
        orderedServiceInCategoryCount
        orderedServiceInCategoryList @skip(if: $skipExport) {
          id
          name
        }
        links @skip(if: $skipExport) {
          title
          url
        }
        tagCount
        tagList @skip(if: $skipExport) {
          id
          name
        }
        commodityGroupCount
        commodityGroupList @skip(if: $skipExport) {
          id
          name
        }
        orderVolumeCumulative
        orderVolumeCumulativeYear
        orderVolumeShare
        orderVolumeShareYear
      }
      totalCount
    }
  }
`);
